import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";

class AliasesDetail extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    const node = this.props.aliasNode ? this.props.aliasNode : this.props.node;
    if (node !== undefined && node.alias !== undefined) {
      _.forEach(node.alias, (alias, index) => {
        if (this.props.showAkas) {
          const akas = _.get(node, "AKAs[0]._", "");
          if (akas !== "") {
            rows.push(
              <Table.Row key={`alias_${index}`}>
                <Table.Cell colSpan={2}>NAME:</Table.Cell>
                <Table.Cell colSpan={2}>{akas}</Table.Cell>
              </Table.Row>
            );
          }
        } else {
          rows.push(
            <Table.Row key={`alias_${index}`}>
              <Table.Cell>NAME:</Table.Cell>
              <Table.Cell>{alias.fullName[0]._}</Table.Cell>
              <Table.Cell>DATE OF BIRTH:</Table.Cell>
              <Table.Cell>{this.props.dob}</Table.Cell>
            </Table.Row>
          );
        }
      });
    }

    return (
      <Table>
        <Table.Body>
          <Table.Row className="report-sub-section-header">
            <Table.HeaderCell colSpan={4}>
              Aliases/A.K.A Used by Subject
            </Table.HeaderCell>
          </Table.Row>
          {rows}
        </Table.Body>
      </Table>
    );
  }
}

export default AliasesDetail;



// WEBPACK FOOTER //
// ./src/components/reports/AliasesDetail.js